/**
 *
 * Styles for WCCOfferCardHeader
 *
 */

import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { IconButtonTooltip, Headline } from "root/libs/ui-components/src";
import { DhlText } from "@dhl-official/react-library";

export const StyledOfferCardHeader = styled.div`
  position: relative;
  align-items: flex-start;
  padding: var(--dui-size-space-10x) var(--dui-size-space-10x)
    ${(props) =>
      !props.isHighlighted
        ? "var(--dui-size-space-10x)"
        : "var(--dui-size-space-5x)"}
    var(--dui-size-space-10x);
  margin-bottom: var(--dui-size-space-10x);
  display: flex;
  background-color: ${(props) =>
    props.isHighlighted ? "var(--dui-color-yellow-500)" : ""};
  box-shadow: ${(props) =>
    !props.isHighlighted ? `0 3px 8px 0 var(--dui-color-gray-300)` : ""};

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-left: ${(props) =>
      props.isLast && props.expandedCardIndex === null
        ? "var(--dui-size-space-20x)"
        : false};
  }
`;

export const StyledHeadline = styled(Headline)`
  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-bottom: var(--dui-size-space-4x);
    font-size: var(--dui-size-font-xl) !important;
    line-height: 24px !important;
  }
`;

export const StyledIconWrapper = styled.div`
  border-radius: 50%;
  padding: 0;
  background-color: var(--dui-color-white-500);
  border: 1px solid var(--dui-color-black-500);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledHeadingWrapper = styled.div`
  padding-left: var(--dui-size-space-5x);
  padding-right: var(--dui-size-space-5x);
  z-index: 0;
`;

export const SubHeadline = styled(DhlText)`
  display: none;

  @media screen and (min-width: ${breakpoints.tablet}) {
    display: block;
  }
`;

export const StyledIconButtonTooltip = styled(IconButtonTooltip)`
  position: absolute;
  right: 0;
  top: 0;

  /* 344px = Samsung Galazy Fold */
  &.wcc-offer-card-tooltip-sm {
    .tooltip-container {
      max-width: 344px !important;
      & > div[data-testid] {
        width: 314px !important;
      }
    }
  }

  &.wcc-offer-card-tooltip-md {
    .tooltip-container {
      max-width: 360px !important;
      & > div[data-testid] {
        width: 330px !important;
      }
    }
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    right: ${(props) =>
      props.isFirst && props.expandedCardIndex === null
        ? "var(--dui-size-space-10x)"
        : false};
  }
`;
